import { useEffect } from 'react'

import { mpostApi } from 'redux/services/mpost'
import { GetMpostParams } from 'redux/services/mpost/types'

import { AppStatistics } from 'components/AppStatistics/AppStatistics'

interface StatisticsProps {
  filters: GetMpostParams
}

export function Statistics({ filters }: StatisticsProps) {
  const [fetch, fetchState] = mpostApi.useLazyMpostStatisticsQuery()

  useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  if (fetchState.isSuccess) {
    return <AppStatistics list={fetchState.data} />
  }
  return null
}
